import { render, staticRenderFns } from "./RequestSection.vue?vue&type=template&id=51a12dc6&"
import script from "./RequestSection.vue?vue&type=script&lang=js&"
export * from "./RequestSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports